/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteFaqMutationResponse,
  DeleteFaqPathParams,
} from "../types/DeleteFaq.ts"

export const deleteFaqMutationKey = () =>
  [{ url: "/v1/faq/delete-faq/:id" }] as const

export type DeleteFaqMutationKey = ReturnType<typeof deleteFaqMutationKey>

/**
 * @summary Delete a FAQ
 * {@link /v1/faq/delete-faq/:id}
 */
export async function deleteFaq(
  id: DeleteFaqPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteFaqMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "DELETE", url: `/v1/faq/delete-faq/${id}`, ...requestConfig })
  return res
}

export function deleteFaqMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = deleteFaqMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteFaqPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteFaq(id, config)
    },
  })
}

/**
 * @summary Delete a FAQ
 * {@link /v1/faq/delete-faq/:id}
 */
export function useDeleteFaq<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteFaqMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: DeleteFaqPathParams["id"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deleteFaqMutationKey()

  const baseOptions = deleteFaqMutationOptions(config) as UseMutationOptions<
    ResponseConfig<DeleteFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteFaqPathParams["id"] },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteFaqPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteFaqMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteFaqPathParams["id"] },
    TContext
  >
}
